'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$$asyncApi = exports.chromeStorage = exports.localStorage = undefined;

var _localStorage = require('./localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

var _chromeStorage = require('./chromeStorage');

var _chromeStorage2 = _interopRequireDefault(_chromeStorage);

var _asyncApiSymbol = require('./asyncApiSymbol');

var _asyncApiSymbol2 = _interopRequireDefault(_asyncApiSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.localStorage = _localStorage2.default;
exports.chromeStorage = _chromeStorage2.default;
exports.$$asyncApi = _asyncApiSymbol2.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/storage/index.js
// module id = 462
// module chunks = 0